import { render, staticRenderFns } from "./gunRecord.vue?vue&type=template&id=392f349c&scoped=true"
import script from "./gunRecord.vue?vue&type=script&lang=js"
export * from "./gunRecord.vue?vue&type=script&lang=js"
import style0 from "./gunRecord.vue?vue&type=style&index=0&id=392f349c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392f349c",
  null
  
)

export default component.exports